export const DOWNLOAD_PAYROLL_TEMPLATE_FILE =
    "@PAYROLL_FILE/DOWNLOAD_PAYROLL_TEMPLATE_FILE";

export const DOWNLOAD_PAYROLL_TEMPLATE_FILE_DONE =
    "@PAYROLL_FILE/DOWNLOAD_PAYROLL_TEMPLATE_FILE_DONE";

export const UPLOAD_PAYROLL_FILE = "@PAYROLL_FILE/UPLOAD_PAYROLL_FILE";

export const UPLOAD_PAYROLL_FILE_DONE =
    "@PAYROLL_FILE/UPLOAD_PAYROLL_FILE_DONE";

export const GET_PAYROLL_FILE_PROCESS =
    "@PAYROLL_FILE/GET_PAYROLL_FILE_PROCESS";
export const GET_PAYROLL_FILE_PROCESS_DONE =
    "@PAYROLL_FILE/GET_PAYROLL_FILE_PROCESS_DONE";

export const SHOW_PAYROLL_FILE_ERROR_MODAL =
    "@PAYROLL_FILE/SHOW_PAYROLL_FILE_ERROR_MODAL";

export const CLOSE_PAYROLL_FILE_ERROR_MODAL =
    "@PAYROLL_FILE/CLOSE_PAYROLL_FILE_ERROR_MODAL";

export const CLEAR_PAYROLL_FILE = "@PAYROLL_FILE/CLEAR_PAYROLL_FILE";
